import type { AuthenticationConfig } from '@tbitop/authentication';
import { WebAdapter } from '@tbitop/keycloak/web';
import type { StageParameters } from '../../stage/stage-parameters';

export type AuthenticationEnvSetting = ReturnType<typeof getAuthenticationConfig>;

type AuthenticationConfigParams =
  Partial<Pick<AuthenticationConfig, 'resourceName'>> &
  Pick<AuthenticationConfig, 'clientId'> &
  Partial<Pick<AuthenticationConfig, 'redirectUris'>> &
  Partial<Pick<AuthenticationConfig, 'adapter'>>;

export const getAuthenticationConfig = (
  stageParameters: StageParameters,
  { resourceName, clientId, redirectUris = {}, adapter = WebAdapter }: AuthenticationConfigParams,
): AuthenticationConfig => ({
  clientId,
  resourceName,
  getInstanceUrl: () => getAuthenticationUrl(stageParameters),
  redirectUris,
  adapter,
});

const getAuthenticationUrl = (stageParameters: StageParameters) => {
  const authenticationBaseUrl = getAuthenticationBaseUrl(stageParameters);
  return `${authenticationBaseUrl}/auth/`;
};

const getAuthenticationBaseUrl = ({ baseUrl, authenticationBaseUrl }: StageParameters) => {
  if (authenticationBaseUrl) {
    return authenticationBaseUrl;
  }
  return `${baseUrl}login`;
};

